import { render, staticRenderFns } from "./TicketProcessDefinitions.vue?vue&type=template&id=8a8ab374&scoped=true"
import script from "./TicketProcessDefinitions.vue?vue&type=script&lang=js"
export * from "./TicketProcessDefinitions.vue?vue&type=script&lang=js"
import style0 from "./TicketProcessDefinitions.vue?vue&type=style&index=0&id=8a8ab374&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8ab374",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCol,VForm,VRow,VTextField})
